import { configureStore } from '@reduxjs/toolkit'
import projectReducer from './slices/projectSlice'
import featureFlagsReducer from './slices/featureFlagsSlice'
import dataSourcesReducer from './slices/dataSourcesSlice'

export const store = configureStore({
  reducer: {
    project: projectReducer,
    featureFlags: featureFlagsReducer,
    dataSources: dataSourcesReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch